import React from "react";

const SearchIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 8.11973C1.00004 4.72331 3.37157 1.79992 6.66418 1.13744C9.95687 0.474962 13.2536 2.25793 14.538 5.39591C15.8226 8.53391 14.7371 12.1529 11.9456 14.0395C9.15408 15.9262 5.43391 15.5551 3.06037 13.1531C1.7411 11.8181 0.999976 10.0075 1 8.11973Z"
        stroke="#3F3F3F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.8462 14.8462L21 21"
        stroke="#3F3F3F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SearchIcon;
